import { render } from "./Index.vue?vue&type=template&id=60cf6dce&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=60cf6dce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60cf6dce"

export default script